(function () {
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Delay (ms) between consecutive requests to stay under Shopify's rate limit.
  var REQUEST_DELAY = 350;

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // fetch wrapper with automatic retry/back-off on 429 (Too Many Requests).
  async function fetchWithRetry(url, options, maxRetries) {
    maxRetries = maxRetries == null ? 4 : maxRetries;
    for (var attempt = 0; ; attempt++) {
      var res = await fetch(url, options);
      if (res.status !== 429 || attempt >= maxRetries) return res;
      var retryAfter = parseFloat(res.headers.get('Retry-After'));
      var waitMs = (isNaN(retryAfter) ? Math.pow(2, attempt) : retryAfter) * 1000;
      await sleep(waitMs);
    }
  }

  function toBool(value) {
    return String(value) === 'true';
  }

  // Czech pluralization: 1 -> položka, 2-4 -> položky, 0 & 5+ -> položek
  function itemCountLabel(count) {
    var word;
    if (count === 1) {
      word = 'položka';
    } else if (count >= 2 && count <= 4) {
      word = 'položky';
    } else {
      word = 'položek';
    }
    return count + ' ' + word;
  }

  function hasValue(value) {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  async function suggestProducts(query) {
    var url =
      ROOT_URL +
      'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,variants.sku,variants.barcode,variants.title';
    var res = await fetchWithRetry(url).then(function (r) { return r.json(); });
    return (((res || {}).resources || {}).results || {}).products || [];
  }

  async function resolveVariant(sku) {
    var clean = String(sku).trim();
    var target = clean.toLowerCase();
    // Quoted phrase first (avoids "-" being read as a NOT operator), then fallbacks.
    var queries = ['"' + clean + '"', clean, clean.replace(/[-_/]/g, ' ')];
    var seen = {};

    for (var q = 0; q < queries.length; q++) {
      var products = await suggestProducts(queries[q]);
      for (var i = 0; i < products.length; i++) {
        var handleUrl = products[i].url.split('?')[0];
        if (seen[handleUrl]) continue;
        seen[handleUrl] = true;
        try {
          var product = await fetchWithRetry(handleUrl + '.js').then(function (r) { return r.json(); });
          var variant = product.variants.find(function (v) {
            return v.sku && v.sku.toString().trim().toLowerCase() === target;
          });
          if (variant) {
            return {
              id: variant.id,
              available: variant.available,
              title: product.title,
              variantTitle: variant.title
            };
          }
        } catch (e) { /* try next candidate */ }
      }
    }
    return null;
  }

  async function clearCart() {
    await fetchWithRetry(ROOT_URL + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // Adds a single line item; resolves to { ok, message } so one failure never aborts the batch.
  async function addItem(item) {
    try {
      var res = await fetchWithRetry(ROOT_URL + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity }] })
      });
      if (res.ok) return { ok: true };
      var data = {};
      try { data = await res.json(); } catch (e) { /* non-JSON error body */ }
      return { ok: false, message: data.description || data.message || 'Nepodařilo se přidat' };
    } catch (e) {
      return { ok: false, message: 'Chyba připojení' };
    }
  }

  function renderErrors(container, errors) {
    if (!errors.length) { container.innerHTML = ''; return; }
    var rows = errors.map(function (e) {
      return '<tr><td>' + e.sku + '</td><td>' + e.name + '</td><td>' + e.status + '</td></tr>';
    }).join('');
    container.innerHTML =
      '<table><thead><tr><th>Kód</th><th>Produkt</th><th>Stav</th></tr></thead><tbody>' +
      rows + '</tbody></table>';
  }

  function initForm(root) {
    if (!root || root.dataset.excelInit === 'true') return;
    root.dataset.excelInit = 'true';

    var fileInput = root.querySelector('[data-excel-file]');
    var fileLabel = root.querySelector('[data-excel-file-label]');
    var fileName = root.querySelector('[data-excel-file-name]');
    var confirmBtn = root.querySelector('[data-excel-confirm]');
    var statusEl = root.querySelector('[data-excel-status]');
    var errorsEl = root.querySelector('[data-excel-errors]');

    var skuColumn = root.dataset.skuColumn || 'Kód';
    var qtyColumn = root.dataset.qtyColumn || 'Množství';
    var shouldClearCart = toBool(root.dataset.clearCart);
    var redirectToCart = toBool(root.dataset.redirectToCart);

    var rows = [];

    if (fileLabel && fileInput) {
      fileLabel.addEventListener('click', function () { fileInput.click(); });
    }

    fileInput.addEventListener('change', function (e) {
      errorsEl.innerHTML = '';
      statusEl.textContent = '';
      var file = e.target.files && e.target.files[0];
      if (!file) { confirmBtn.classList.add('hide'); return; }
      if (fileName) fileName.textContent = file.name;

      var reader = new FileReader();
      reader.onload = function (ev) {
        if (typeof XLSX === 'undefined') {
          statusEl.textContent = 'Knihovnu pro zpracování tabulky se nepodařilo načíst. Obnovte prosím stránku a zkuste to znovu.';
          return;
        }
        var data = new Uint8Array(ev.target.result);
        var workbook = XLSX.read(data, { type: 'array' });
        var sheet = workbook.Sheets[workbook.SheetNames[0]];
        rows = XLSX.utils.sheet_to_json(sheet);
        var itemCount = rows.filter(function (row) { return hasValue(row[skuColumn]); }).length;
        statusEl.textContent = 'Nalezeno: ' + itemCountLabel(itemCount);
        confirmBtn.classList.toggle('hide', itemCount === 0);
      };
      reader.readAsArrayBuffer(file);
    });

    confirmBtn.addEventListener('click', async function () {
      if (!rows.length) return;
      confirmBtn.disabled = true;
      errorsEl.innerHTML = '';
      statusEl.textContent = 'Zpracování objednávky…';

      var items = rows
        .map(function (row) {
          return { sku: row[skuColumn], quantity: parseInt(row[qtyColumn], 10) || 1 };
        })
        .filter(function (item) { return hasValue(item.sku); });

      var toAdd = [];
      var errors = [];

      for (var i = 0; i < items.length; i++) {
        statusEl.textContent = 'Vyhledávání produktů… (' + (i + 1) + '/' + items.length + ')';
        if (i > 0) await sleep(REQUEST_DELAY);
        var variant = await resolveVariant(items[i].sku);
        if (!variant) {
          errors.push({ sku: items[i].sku, name: '\u2014', status: 'Nenalezeno' });
        } else if (!variant.available) {
          errors.push({ sku: items[i].sku, name: variant.title, status: 'Nedostupné' });
        } else {
          toAdd.push({ id: variant.id, quantity: items[i].quantity, sku: items[i].sku, title: variant.title });
        }
      }

      if (shouldClearCart) await clearCart();

      // Add everything in ONE request (avoids rate limiting). Fall back to
      // per-item adds only if the bulk call fails on availability (422).
      var addedCount = 0;
      if (toAdd.length) {
        statusEl.textContent = 'Přidávání položek do košíku…';
        var bulkRes = await fetchWithRetry(ROOT_URL + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: toAdd.map(function (t) { return { id: t.id, quantity: t.quantity }; })
          })
        });

        if (bulkRes.ok) {
          var bulkData = {};
          try { bulkData = await bulkRes.json(); } catch (e) { /* ignore */ }
          addedCount = (bulkData.items || []).length || toAdd.length;
        } else {
          // Availability conflict: reset and add one-by-one to salvage the rest.
          await clearCart();
          for (var j = 0; j < toAdd.length; j++) {
            statusEl.textContent = 'Přidávání položek… (' + (j + 1) + '/' + toAdd.length + ')';
            if (j > 0) await sleep(REQUEST_DELAY);
            var result = await addItem(toAdd[j]);
            if (result.ok) {
              addedCount += 1;
            } else {
              errors.push({ sku: toAdd[j].sku, name: toAdd[j].title, status: result.message });
            }
          }
        }
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

      if (addedCount === 0) {
        statusEl.textContent = 'Nepodařilo se přidat žádnou položku.';
        renderErrors(errorsEl, errors);
        confirmBtn.disabled = false;
        return;
      }

      // No problems: honour the redirect-to-cart setting.
      if (errors.length === 0 && redirectToCart) {
        window.location.href = ROOT_URL + 'cart';
        return;
      }

      // Some items failed: stay so the customer can read the summary, and offer a cart link.
      statusEl.textContent = 'Do košíku přidáno: ' + itemCountLabel(addedCount) +
        (errors.length ? '. U následujících položek nastal problém:' : '.');
      renderErrors(errorsEl, errors);

      if (redirectToCart) {
        var cartLink = document.createElement('a');
        cartLink.href = ROOT_URL + 'cart';
        cartLink.className = 'btn btn--primary excel-order-form__cart-link';
        cartLink.innerHTML = '<span>Přejít do košíku</span>';
        errorsEl.appendChild(cartLink);
      }

      confirmBtn.disabled = false;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.excel-order-form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
